/* unplugin-vue-components disabled */import { render } from "./audioItem.vue?vue&type=template&id=3a05277c&scoped=true"
import script from "./audioItem.vue?vue&type=script&lang=js"
export * from "./audioItem.vue?vue&type=script&lang=js"

import "./audioItem.vue?vue&type=style&index=0&id=3a05277c&scoped=true&lang=scss"
import "./audioItem.vue?vue&type=style&index=1&id=3a05277c&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a05277c"]])

export default __exports__